
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const MainContent = () => {
  const navigate = useNavigate();

  const handleParticularClick = () => {
    navigate("/particulier");
  };

  const handleProClick = () => {
    navigate("/pro");
  };

  return (
    <section className="min-h-[80vh] flex flex-col items-center justify-center px-4 text-center max-w-6xl mx-auto">
      <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-primary mb-6">
        Découvrez l'Aisne Autrement avec NLocale
        <span className="block text-secondary mt-2">
          L'Aisne en Trois Temps :<br />
          Saveurs, Ambiances, Émotions !
        </span>
      </h1>
      
      <p className="text-xl sm:text-2xl text-gray-600 mb-12 max-w-3xl">
        Parce que l'Aisne a plus à offrir qu'on ne le pense…<br />
        même si les paysages sont déjà magnifiques.
      </p>

      <div className="text-lg text-gray-700 mb-16 max-w-3xl">
        Chez NLocale, on vous invite à redécouvrir l'Aisne, que vous soyez touriste ou résident. 
        Explorez des adresses locales, réservez vos prochaines sorties et vivez des expériences authentiques. 
        Parce que bien manger, bien boire et bien dormir, c'est possible ici aussi.
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full max-w-5xl px-4">
        <div className="space-y-4">
          <Button 
            onClick={handleParticularClick}
            className="w-full min-h-[4rem] text-base sm:text-lg px-4 whitespace-normal flex flex-col"
            variant="default"
          >
            <span>Je suis un particulier</span>
            <span>Découvrir l'Aisne sans se prendre la tête !</span>
          </Button>
          <p className="text-sm text-gray-600">
            Que vous soyez touriste ou résident, trouvez votre prochaine adresse coup de cœur grâce à NLocale.
          </p>
        </div>

        <div className="space-y-4">
          <Button 
            onClick={handleProClick}
            className="w-full min-h-[4rem] text-base sm:text-lg px-4 whitespace-normal flex flex-col"
            variant="secondary"
          >
            <span>Je suis un professionnel</span>
            <span>Rejoindre la communauté locale</span>
          </Button>
          <p className="text-sm text-gray-600">
            Vous êtes un acteur du tourisme ou de l'hôtellerie-restauration ? Boostez votre visibilité avec NLocale.
          </p>
        </div>
      </div>
    </section>
  );
};
